import { render, staticRenderFns } from "./Taglist.vue?vue&type=template&id=3f487ba8&"
import script from "./Taglist.vue?vue&type=script&lang=js&"
export * from "./Taglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports